(() => {
  'use strict';
  const gallery = document.querySelector('media-gallery');
  const config = document.querySelector('[data-stt-zoom-config]');
  if (!gallery || !config || gallery.classList.contains('stt-inline-ready')) return;
  gallery.classList.add('stt-inline-ready');
  const labels = {
    pt:{reset:'Repor imagem'}, en:{reset:'Reset image'}, es:{reset:'Restablecer imagen'}
  };
  const locale = (document.documentElement.lang || 'pt').slice(0,2);
  const resetLabel = (labels[locale] || labels.pt).reset;
  const openers = Array.from(gallery.querySelectorAll('.product__modal-opener--image'));
  const state = new Map();
  const clamp = (v,a,b) => Math.max(a,Math.min(b,v));
  let activePinch = null;
  let lastTouch = null;

  function apply(opener) {
    const s = state.get(opener);
    if (!s) return;
    opener.style.setProperty('--stt-inline-scale',String(s.scale));
    opener.style.setProperty('--stt-inline-origin',s.originX+'% '+s.originY+'%');
    opener.style.setProperty('--stt-inline-x',s.x+'px');
    opener.style.setProperty('--stt-inline-y',s.y+'px');
    const reset = s.reset;
    if (reset) reset.hidden = s.scale < 1.02 || s.lastInput === 'mouse';
  }
  function clear(opener) {
    const s = state.get(opener);
    if (!s) return;
    s.scale=1; s.x=0; s.y=0; s.originX=50; s.originY=50;
    apply(opener);
  }
  openers.forEach((opener) => {
    const image = opener.querySelector('.product__media img');
    if (!image) return;
    const s={scale:1,x:0,y:0,originX:50,originY:50,reset:null,lastInput:'mouse'};
    const reset = document.createElement('button');
    reset.type='button';
    reset.className='stt-inline-reset';
    reset.textContent=resetLabel;
    reset.setAttribute('aria-label',resetLabel);
    reset.hidden=true;
    const holder=opener.closest('.product-media-container');
    if (holder) holder.appendChild(reset);
    s.reset=reset;
    state.set(opener,s);
    reset.addEventListener('click',(e)=>{e.preventDefault();e.stopPropagation();clear(opener);});
    opener.addEventListener('pointermove',(event) => {
      if (event.pointerType !== 'mouse') return;
      s.lastInput = 'mouse';
      const rect=opener.querySelector('.product__media')?.getBoundingClientRect();
      if (!rect || !rect.width || !rect.height) return;
      s.originX=clamp((event.clientX-rect.left)/rect.width*100,0,100);
      s.originY=clamp((event.clientY-rect.top)/rect.height*100,0,100);
      s.scale=1.65;
      apply(opener);
    });
    opener.addEventListener('pointerleave',(event)=>{if (event.pointerType === 'mouse') clear(opener);});
  });

  const pinchingDist = (a,b)=>Math.hypot(a.clientX-b.clientX,a.clientY-b.clientY);
  function openerFor(t) {
    const el=t instanceof Element ? t : t?.parentElement;
    const opener=el?.closest('.product__modal-opener--image');
    return opener && gallery.contains(opener) && state.has(opener) ? opener : null;
  }
  gallery.addEventListener('touchstart',(event)=>{
    if (event.touches.length===2) {
      const first=openerFor(event.touches[0].target);
      const second=openerFor(event.touches[1].target);
      if (!first || first!==second) return;
      const s=state.get(first);
      s.lastInput = 'touch';
      const rect=first.querySelector('img')?.getBoundingClientRect();
      if (!rect?.width || !rect?.height) return;
      const cx=(event.touches[0].clientX+event.touches[1].clientX)/2;
      const cy=(event.touches[0].clientY+event.touches[1].clientY)/2;
      s.originX=clamp((cx-rect.left)/rect.width*100,0,100);
      s.originY=clamp((cy-rect.top)/rect.height*100,0,100);
      activePinch={opener:first,distance:pinchingDist(event.touches[0],event.touches[1]),startScale:s.scale};
      gallery.dataset.sttPreventModalUntil = String(Date.now() + 1200);
      lastTouch=null;
    } else if (event.touches.length===1) {
      const opener=openerFor(event.touches[0].target);
      if (opener && state.get(opener).scale>1.02) {
        state.get(opener).lastInput = 'touch';
        activePinch={opener,distance:0,startScale:state.get(opener).scale};
        lastTouch={x:event.touches[0].clientX,y:event.touches[0].clientY};
      }
    }
  },{passive:true});

  gallery.addEventListener('touchmove',(event)=>{
    if (!activePinch) return;
    const s=state.get(activePinch.opener);
    if (!s) return;
    if (event.touches.length===2) {
      if (activePinch.distance===0) {
        activePinch.distance=pinchingDist(event.touches[0],event.touches[1]);
        activePinch.startScale=s.scale;
      }
      s.scale=clamp(activePinch.startScale*pinchingDist(event.touches[0],event.touches[1])/Math.max(1,activePinch.distance),1,2.5);
      if (s.scale<=1.01){s.scale=1;s.x=0;s.y=0;}
      apply(activePinch.opener);
      lastTouch=null;
      if (event.cancelable) event.preventDefault();
    } else if (event.touches.length===1 && s.scale>1.02) {
      const now={x:event.touches[0].clientX,y:event.touches[0].clientY};
      if (lastTouch) {
        const rect=activePinch.opener.getBoundingClientRect();
        const limitX=Math.max(0,(rect.width*(s.scale-1))/2);
        const limitY=Math.max(0,(rect.height*(s.scale-1))/2);
        s.x=clamp(s.x+(now.x-lastTouch.x),-limitX,limitX);
        s.y=clamp(s.y+(now.y-lastTouch.y),-limitY,limitY);
        apply(activePinch.opener);
      }
      lastTouch=now;
      if (event.cancelable) event.preventDefault();
    }
  },{passive:false});
  gallery.addEventListener('touchend',(event)=>{
    if (!activePinch) return;
    if (!event.touches.length) {
      gallery.dataset.sttPreventModalUntil = String(Date.now() + 600);
      activePinch=null;lastTouch=null;
    }
    else if(event.touches.length===1) {
      lastTouch={x:event.touches[0].clientX,y:event.touches[0].clientY};
      activePinch.distance=0;
    }
  },{passive:true});
  gallery.addEventListener('touchcancel',()=>{activePinch=null;lastTouch=null;},{passive:true});
  gallery.querySelector('[id^="GalleryViewer"]')?.addEventListener('slideChanged',()=>openers.forEach(clear));
  // Thumbnail clicks may replace media without a slideChanged event.
  gallery.querySelector('[id^="GalleryThumbnails"]')?.addEventListener('click',(event)=>{
    if (event.target.closest('[data-target]')) openers.forEach(clear);
  });
  window.addEventListener('resize',()=>openers.forEach(clear),{passive:true});
})();
